import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const WarrantyDetailPage = lazyLoader(
  () => import("Containers/Warranty/WarrantyDetail/WarrantyDetail")
);

export const WarrantyDetail = () => {
  return (
    <Layout>
      <WarrantyDetailPage />
    </Layout>
  );
};
